module.exports = __webpack_public_path__ + "img/arrow-down-filter-modal.48527f24.svg";